import React, { useEffect } from "react";
import Header from "../Header";
import MainComponent from "../MainComponent";
import Footer from "../Footer";
import FooterDown from "../FooterDown";
import BlogDetail from "./BlogDetail";
import { useParams } from "react-router-dom";
import { blogPosts } from "./blogData";

const BlogDetailPage = () => {
    const { slug } = useParams();
    const post = blogPosts.find((p) => p.slug === slug);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <Header />
            <MainComponent type='blogs' postTitle={post?.title} />
            <BlogDetail />
            <Footer />
            <FooterDown />
        </div>
    );
};

export default BlogDetailPage;
